export default function accordionContent (document, moduleHTML, appEventEmitter) {
  const sectionsOpen = moduleHTML.dataset.jsAccordionContent
  const accordionTabs = moduleHTML.querySelectorAll('[data-js-accordion-title]')
  const contentBlocks = Array.from(moduleHTML.querySelectorAll('[data-js-content]'))

  const toggleContentDisplay = (event) => {
    const dropDownIcon = event.target.querySelector('[data-js-accordion-icon]')
    const currentContentBlock = event.target.nextSibling

    if (sectionsOpen.toLowerCase() === 'one') {
      contentBlocks
        .filter((contentBlock) => contentBlock !== currentContentBlock)
        .forEach((contentBlock) => {
          const icon = contentBlock.previousSibling.querySelector('[data-js-accordion-icon]')
          icon && icon.classList.remove('rotate-180')
          contentBlock.classList.add('hidden')
          contentBlock.classList.remove('block')
        })
    }
    ['hidden', 'block'].forEach((cls) => currentContentBlock.classList.toggle(cls))
    dropDownIcon.classList.toggle('rotate-180')
  }

  accordionTabs.forEach((accordionTab) => {
    accordionTab.addEventListener('click', toggleContentDisplay)
  })
}
